import React from 'react';

const TU = props => {
  if (props.tag && props.tag === 'div') {
    return (
      <div
        className={props.className}
        dangerouslySetInnerHTML={{ __html: props.text }}
      />
    );
  }
  return (
    <span
      className={props.className}
      dangerouslySetInnerHTML={{ __html: props.text }}
    />
  );
};

TU.propTypes = {
  className: React.PropTypes.string,
  text: React.PropTypes.string,
  tag: React.PropTypes.oneOf([undefined, 'div', 'span'])
};

export default TU;



// WEBPACK FOOTER //
// ./frontend/react/components/common/tu/index.js